import script from "./FormationView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormationView.vue?vue&type=script&setup=true&lang=js"

import "./FormationView.vue?vue&type=style&index=0&id=22c04a35&lang=css"

const __exports__ = script;

export default __exports__